import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstanceTranslation } from "../Entity/TreeNodeSubstanceTranslation";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceTranslationList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Substance Translations ({param})');
      this.parent = parent;
      this.labelNodeName = 'Substance Translations';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstanceTranslation(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
  
      return [node];
    }
  
    override getMessage(): any {
      let substancetranslations: Art57Node[] = [];
      this.children?.forEach((node) => {
        let substancetranslation = node as Art57Node;
        substancetranslations.push(substancetranslation.getMessage());
      });
  
      if (substancetranslations.length > 0) {
        return {
          substancetranslations: { substancetranslation: substancetranslations },
        };
      } else {
        return undefined;
      }
    }

    override getHeaders(): string[] {
      return ['Language Code', 'Translation'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceTranslationList =
        new TreeNodeSubstanceTranslationList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }